module.exports = __webpack_public_path__ + "img/band-yelow.6c3d2d07.svg";